// extracted by mini-css-extract-plugin
export default {"NotFound":"NotFoundPage_NotFound__9iPmU","title":"NotFoundPage_title__A+nLL"};